import { DayRange, BusinessHoursOption } from '.';
import { BusinessHoursViewModel } from '../../models';
import DateTimeService from '@/shared/services/dateTime';
import { store } from '@/store';
import { HolidayViewModel } from '@/features/bots/models/holidayViewModel';

export class BusinessHoursOptions {
  public static dayOptions: DayRange[] = [
    { name: 'Monday', startDay: 0, endDay: 0, key: '0-0' },
    { name: 'Tuesday', startDay: 1, endDay: 1, key: '1-1' },
    { name: 'Wednesday', startDay: 2, endDay: 2, key: '2-2' },
    { name: 'Thursday', startDay: 3, endDay: 3, key: '3-3' },
    { name: 'Friday', startDay: 4, endDay: 4, key: '4-4' },
    { name: 'Saturday', startDay: 5, endDay: 5, key: '5-5' },
    { name: 'Sunday', startDay: 6, endDay: 6, key: '6-6' },
  ];

  public static dayRangeOptions: DayRange[] = [
    { name: 'Every day', startDay: 0, endDay: 6, key: '0-6' },
    { name: 'Weekdays', startDay: 0, endDay: 4, key: '0-4' },
    { name: 'Weekends', startDay: 5, endDay: 6, key: '5-6' },
  ];

  public static getDefaultOption(): BusinessHoursOption {
    const everyDayOption = this.findDayRangeOption(this.defaultDayStart, this.defaultDayEnd);
    return new BusinessHoursOption(everyDayOption, true, this.defaultTimeStart, this.defaultTimeEnd);
  }

  public static getDefaultModel(): BusinessHoursViewModel {
    return {
      startDay: this.defaultDayStart,
      endDay: this.defaultDayEnd,
      closed: false,
      startTime: DateTimeService.getMinutes(this.defaultTimeStart),
      endTime: DateTimeService.getMinutes(this.defaultTimeEnd),
    };
  }

  public static findDayRangeOption(startDay?: number, endDay?: number, holidayId?: string): DayRange {
    const options = [...this.dayOptions, ...this.dayRangeOptions, ...BusinessHoursOptions.getHolidayOptions()];

    const option = options.find(
      (range) =>
        (startDay != null && endDay != null && range.startDay === startDay && range.endDay === endDay) ||
        (holidayId != null && range.holidayId === holidayId),
    );

    if (!option) {
      throw new Error('could not find option');
    }

    return option;
  }

  private static defaultDayStart = 0;
  private static defaultDayEnd = 6;
  private static defaultTimeStart = '09:00';
  private static defaultTimeEnd = '17:00';

  private static getHolidayOptions(): DayRange[] {
    return store.getters.holidays.map((h: HolidayViewModel) => ({ name: h.name, holidayId: h.id }));
  }
}
